import React, { type ReactElement } from 'react'
import { Icon, Switch, Tooltip, Typography } from 'shared/ui'
import styles from './styles.module.scss'

type IToggleCardProps = {
  title: string
  labelTooltip: ReactElement
  description: string
  value: boolean
  setValue: (value: boolean) => void
}

export const ToggleCard = ({
  title,
  labelTooltip,
  description,
  value,
  setValue,
}: IToggleCardProps) => (
  <div className={styles.toggleCard}>
    <div className={styles.left}>
      <div className={styles.row}>
        <Typography ariaLabel={'title'} variant={'body-md-medium'}>
          {title}
        </Typography>
        <Tooltip label={labelTooltip} placement={'top'}>
          <Icon
            icon={'questionFull'}
            color={'var(--content-neutral-primary)'}
            fontSize={12}
            padding={2}
          />
        </Tooltip>
      </div>
      <Typography ariaLabel={'description'} color={'tertiary'} variant={'body-md-regular'}>
        {description}
      </Typography>
    </div>
    <div className={styles.right}>
      <Switch value={value} onChange={setValue} size={'middle'} />
    </div>
  </div>
)
